import { GifSearch, ImageSearch } from 'grow.client';

export const isImageSearch = (image: ImageSearch | GifSearch): image is ImageSearch => {
    return (image as ImageSearch).color !== undefined
}